export default "__VITE_ASSET__31659463__"